export const CUSTOMER_INFO_RECEIVED = "CUSTOMER_INFO_RECEIVED";
export const CUSTOMER_PAYMENT_METHODS_RECEIVED =
  "CUSTOMER_PAYMENT_METHODS_RECEIVED";
export const CUSTOMER_INFO_BY_ID_RECEIVED = "CUSTOMER_INFO_BY_ID_RECEIVED";
